import { render, staticRenderFns } from "./FlightsVerification.vue?vue&type=template&id=b85c94a8&scoped=true&"
import script from "./FlightsVerification.vue?vue&type=script&lang=js&"
export * from "./FlightsVerification.vue?vue&type=script&lang=js&"
import style0 from "./FlightsVerification.vue?vue&type=style&index=0&id=b85c94a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85c94a8",
  null
  
)

export default component.exports